import {get} from "../../../../GlobalModules/Utility/Http";
import {storeListGet} from "../Model/StoreModel";

/**
 * Fetch store list with optional filters
 * @param {Object} filters - Filter parameters for the API call
 * @returns {Promise} Processed store list data
 */
export const getStoreList = async (filters = {}) => {
    // Format filters according to the API structure in Postman collection
    let queryParams = {};

    if (filters) {
        // Handle search term
        if (filters.search) {
            queryParams.filter_op = JSON.stringify({search_attr: "substring"});
            queryParams.filters = JSON.stringify({
                limit: filters.limit,
                offset: filters.offset || 0,
                search_attr: filters.search,
            });
        } else {
            // Handle pagination and sorting
            const filtersObj = {
                limit: filters.limit,
                offset: filters.offset || 0,
            };

            queryParams.filters = JSON.stringify(filtersObj);
        }
    }

    const response = await get(`${process.env.EXTENDED_URL}/store`, queryParams);
    return storeListGet(response);
};